import React from 'react';
import iconTopic from 'src/assets/images/icons/help-topic.svg';

interface TopicSidebarProps {
  activeTopic?: string;
  onTopicClick?: (topic: string) => void;
}

const TOPICS = [
  'Getting Started',
  'Invoice Upload',
  'Reviewing Audit Exceptions',
  'Audit Workflows',
  'Resolving Invoice Issues',
  'Understanding Charge Deviations',
  'Handling Disputes',
  'Handling "No Rate Card Found" (NRCF)',
  'FREYA Report & Analytics',
  'FREYA Performance Assessment',
  'Rate Card Manager Feature',
];

export const TopicSidebar: React.FC<TopicSidebarProps> = ({ activeTopic = 'Getting Started', onTopicClick }) => {
  return (
    <div className='w-[300px] px-48 flex-shrink-0 py-48 min-h-[500px] sticky top-0 self-start flex justify-center'>
      <div className='text-left'>
        {/* Header */}
        <div className='flex items-center gap-12 mb-32'>
          <img src={iconTopic} alt='Topic' />
          <h3 className='text-22 font-semibold text-blue-grey-90 m-0'>Topics</h3>
        </div>

        {/* Nav List */}
        <nav className='flex flex-col space-y-12'>
          {TOPICS.map((topic) => {
            const isActive = topic === activeTopic;
            return (
              <button
                key={topic}
                onClick={() => onTopicClick?.(topic)}
                className={`w-full text-left transition-colors text-14
                                    ${isActive ? 'text-primary font-medium' : 'text-neutral-80 font-medium hover:text-primary'}`}
              >
                {topic}
              </button>
            );
          })}
        </nav>
      </div>
    </div>
  );
};
